import { DeviceRegistrationLocationState } from "../deviceRegistrationLocationState";

export interface PersonalDetailsValues {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  temperatureScale: number | "";
  timeFormat: number | "";
  dateFormat: number | "";
  password: string;
  confirmPassword: string;
}

export interface SiteDetailsValues {
  name: string;
  address: string;
  country: string;
  city: string;
  postalCode: string;
  description: string;
  timezone: string;
  state: string;
}

export interface DiscoveryResult {
  deviceMac: string;
  indoorUnitsCount: number;
  /** True if a technical error cut the discovery poll short — whatever units were found before that are still shown, with a warning and an option to restart. */
  hadError?: boolean;
}

/**
 * Accumulated wizard state for the new-user branch (CM-618), layered on top of
 * the device state from CM-616/617 and threaded the same way — via
 * `history.push`/`goBack`, not the store. See `deviceRegistrationLocationState.ts`
 * for why: a refresh clears `location.state`, which is the intended
 * "refresh restarts the wizard" behaviour for this whole flow.
 */
export interface NewUserFlowState extends DeviceRegistrationLocationState {
  personalDetails?: PersonalDetailsValues;
  customerName?: string;
  siteDetails?: SiteDetailsValues;
  customerId?: string;
  siteId?: string;
  deviceId?: string;
  discoveryResult?: DiscoveryResult;
}

export const hasPersonalDetails = (
  state: NewUserFlowState | undefined
): state is NewUserFlowState & { personalDetails: PersonalDetailsValues } =>
  !!state && !!state.personalDetails;

export const hasCustomerName = (
  state: NewUserFlowState | undefined
): state is NewUserFlowState & { customerName: string } =>
  !!state && !!state.customerName;

export const hasSiteDetails = (
  state: NewUserFlowState | undefined
): state is NewUserFlowState & { siteDetails: SiteDetailsValues } =>
  !!state && !!state.siteDetails;

export const hasDiscoveryResult = (
  state: NewUserFlowState | undefined
): state is NewUserFlowState & { discoveryResult: DiscoveryResult } =>
  !!state && !!state.discoveryResult;
